const BASE_API = process.env.MIX_ENDLESS_API_URL

const state ={
	currencies:[],
	currenciesLoading:true,
	currency:'GBP',
	currencySymbol:'£',
	user:null,
	vimeoId:null,
	videoPlatform:'vimeo',
	init:{},
	adminOnline:false,
	onlineUsers:[],
	timezone:[],
	notifications:[],
	messageNotifications:[],
	consultancyPackages:[]
}
const getters = {
	currenciesGetter:({currencies}) => currencies,
	currenciesLoadingGetter:({currenciesLoading}) => currenciesLoading,
	currencyGetter:({currency}) => currency,
	currencySymbolGetter:({currencySymbol}) => currencySymbol,
	userGetter:({user}) => user,
	vimeoId:({vimeoId}) => vimeoId,
	videoPlatform:({videoPlatform}) => videoPlatform,
	initGetter:({init}) => init,
	timezoneGetter:({timezone}) => timezone,
	notificationsGetter:({notifications}) => notifications,
	messageNotificationsGetter:({messageNotifications}) => messageNotifications,
	consultancyPackagesGetter:({consultancyPackages}) => consultancyPackages,
}

const mutations = {
	setCurrencies : (state,payload) => state.currencies = payload,
	setCurrenciesLoading : (state,payload) => state.currenciesLoading = payload,
	setCurrency : (state,payload) => state.currency = payload,
	setCurrencySymbol : (state,payload) => state.currencySymbol = payload,
	setUser : (state,payload)=> state.user = payload,
	setVimeoId : (state, payload) => state.vimeoId = payload,
	setVideoPlatform : (state, payload) => state.videoPlatform = payload,
	setInit : (state,payload)=> state.init = payload,
	setTimezone : (state,payload)=> state.timezone = payload,
	setNotifications : (state,payload)=> state.notifications = payload,
	setMessageNotifications : (state,payload)=> state.messageNotifications = payload,
	setConsultancyPackages : (state,payload)=> state.consultancyPackages = payload,
}

const actions = {
	async getInit({commit,state}, payload){
		await this.$axios.get(`${BASE_API}/init`).then(res => {
			commit('setInit',res.data.result.auth)
			commit('setUser',res.data.result.user)
			commit('setCurrencies',res.data.result.currencies)
			commit('setCurrency',res.data.result.currency)
			commit('setConsultancyPackages',res.data.result.user.consultancy_packages)
			// Eğer localStorage'da para birimi bilgileri varsa, onları kullan
			const currencyCode = localStorage.getItem('currencyCode') || res.data.result.currency;
			const currencySymbol = localStorage.getItem('currencySymbol') || res.data.result.currency_symbol;

			commit('setCurrency', currencyCode);
			commit('setCurrencySymbol', currencySymbol);

			// Eğer localStorage'da para birimi bilgileri yoksa, API'den gelen bilgileri kaydet
			if (!localStorage.getItem('currencySymbol') || !localStorage.getItem('currencyCode')) {
				localStorage.setItem('currencyCode', currencyCode);
				localStorage.setItem('currencySymbol', currencySymbol);
			}

			commit('setCurrenciesLoading', false);
		}).catch(err => {
			commit('setCurrenciesLoading', false);
			const status = err.response ? err.response.status : null
			if (status === 403){
				axios.post('/logout', {
					// CSRF token to ensure request authenticity
					_token: document.querySelector('meta[name="csrf-token"]').getAttribute('content')
				})
					.then(response => {
						// Redirect or handle success
						window.location.href = '/';
					})
					.catch(error => {
						console.error("Logout failed:", error);
					});
			}
			else commit('setInitError', status)
		})
	},

	async getNotifications({commit,state}, payload){
		await this.$axios.get(`${BASE_API}/notifications?order=desc`).then(res => {
			commit('setNotifications', res.data.result.data)
		})
	},
	async getMessageNotifications({commit,state}, payload){
		await this.$axios.get(`${BASE_API}/notifications/unread-messages`).then(res => {
			commit('setMessageNotifications', res.data.result.data)
		})
	},
	async putReadAllNotifications({commit,state}, payload){
		await this.$axios.put(`${BASE_API}/notifications/mark-all-notifications-as-read`).then(res => {
			state.notifications = state.notifications.map(notification => ({
				...notification,
				viewedAt: true
			}));
		})
	},
	async putReadNotification({commit,state}, payload){
		await this.$axios.put(`${BASE_API}/notifications/${payload.data.notificationId}/mark-as-read`).then(res => {
			(state.notifications.find((x) => x.notificationId === payload.data.notificationId) || {}).viewedAt = true;
			// commit('setNotifications', res.data.result.data)
		})
	},
	changeCurrency({commit}, payload){
		localStorage.setItem('currencyCode', payload.code);
		localStorage.setItem('currencySymbol', payload.symbol);
		commit('setCurrency',payload.code)
		commit('setCurrencySymbol',payload.symbol)
	},

}

export default {namespaced:true,state,getters,mutations,actions}
